import { render, staticRenderFns } from "./GioDistributionChart.vue?vue&type=template&id=05b31e25&scoped=true&"
import script from "./GioDistributionChart.vue?vue&type=script&lang=js&"
export * from "./GioDistributionChart.vue?vue&type=script&lang=js&"
import style0 from "./GioDistributionChart.vue?vue&type=style&index=0&id=05b31e25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b31e25",
  null
  
)

export default component.exports